module.exports = __webpack_public_path__ + "static/media/default_1.bb28bd8c.jpg";